import React from "react";
import { List, ListItem, Stack, Text } from "@origin-digital/ods-core";

export const CloseTransferWarningMessageContentNotRequired: React.FC = () => (
  <Stack space="medium">
    <Text>
      This button updates the request status in OCP to "All done", but does not
      close the Kraken account.
    </Text>
    <Text>It should only be used if:</Text>
    <List>
      <ListItem>
        the builder's account is closed due to the customer opening their own
        account
      </ListItem>
      <ListItem>
        a manual account closure form has been received and processed outside of
        OCP.
      </ListItem>
    </List>
  </Stack>
);

export const CloseTransferWarningMessageContentProcessed: React.FC = () => (
  <Stack space="medium">
    <Text>
      This button updates the request status in OCP to "All done", but does not
      close the Kraken account.
    </Text>
    <Text>
      It should only be used if you have actioned the close/transfer request in
      Kraken
    </Text>
  </Stack>
);
